import serviceImg1 from "../../assets/images/service/1.png";
import ncert12 from "../../assets/images/freeResources/ncert12.png";
import ncert11 from "../../assets/images/freeResources/ncert11.png";
import gk from "../../assets/images/freeResources/gk.png";
import ignou from "../../assets/images/freeResources/ignou.png";
import economicsurvey from "../../assets/images/freeResources/economicsurvey.png";
import nios from "../../assets/images/freeResources/nios.png";
import budget from "../../assets/images/freeResources/budget.png";

export const FREE_RESOURCES = [
  {
    id: 1,
    title: "NCERT 12",
    resourceImg: ncert12,
    resource: [
      {
        subject: "History Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1whoe1iryPc8Wiab7Gn9zyrQnt8_fn5TA/view?usp=drive_link",
      },
      {
        subject: "History Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1QLg-cLlZSByll8LNmbwGU0pBjsY8ZuR-/view?usp=drive_link",
      },
      {
        subject: "History Part-3",
        downloadLink:
          "https://drive.google.com/file/d/1KPQCw3rNIdYkVyZo_fwKXQ6vbzhdADcT/view?usp=drive_link",
      },
      {
        subject: "Contemporary World Politics",
        downloadLink:
          "https://drive.google.com/file/d/1_swCiUVXZB9Gi_9aJLVL8yLnSyA2N-j0/view?usp=drive_link",
      },
      {
        subject: "Heritage Craft Traditions of India",
        downloadLink:
          "https://drive.google.com/file/d/1qy1hmkiXX2m9cs84e1NAXq0vGc_UcaIG/view?usp=drive_link",
      },
      {
        subject: "India People and Economy",
        downloadLink:
          "https://drive.google.com/file/d/1klxH8BZxscQ7DSwCvbxBXujpQLcY6jsv/view?usp=drive_link",
      },
      {
        subject: "Politics In India Since Independence",
        downloadLink:
          "https://drive.google.com/file/d/1wzZe96uflKlFCjlB4GVf3Azsg3JSVyvZ/view?usp=drive_link",
      },
      {
        subject: "Fundamentals On Human Geography",
        downloadLink:
          "https://drive.google.com/file/d/16UC0fgVZhSqTRTdoeh1p0sWvEioRbX9I/view?usp=drive_link",
      },
      {
        subject: "Economics Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1ESYSSSYIwv3941OkVJ1MWmRMxSBpW0EF/view?usp=drive_link",
      },
      {
        subject: "Economics Part-2",
        downloadLink:
          "https://drive.google.com/file/d/16Q7NoxXfwE-SU3Vpsuces9AkUUuIrfK7/view?usp=drive_link",
      },
      {
        subject: "Sociology Part-1",
        downloadLink:
          "https://drive.google.com/file/d/12bKLwqEGTPMrYCDORtnbXhyUvSftc41k/view?usp=drive_link",
      },
      {
        subject: "Sociology Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1-XJA6DZkFjDfWx2Kslo-tJyuac6w1RDu/view?usp=drive_link",
      },
      {
        subject: "Physics Part-1",
        downloadLink:
          "https://drive.google.com/file/d/15csuP9WlWSMjX9DCYDPNUnzlNvFnQq-I/view?usp=drive_link",
      },
      {
        subject: "Physics Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1HY3UtGlc5-ZynjZWl1TMl8rt5ZI9I8hS/view?usp=drive_link",
      },
      {
        subject: "Chemistry Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1MArI-qx0EIVgNv09LiY-_s29Q_UJWe5f/view?usp=drive_link",
      },
      {
        subject: "Chemistry Part-2",
        downloadLink:
          "https://drive.google.com/file/d/12WoZwv49MmqQhL5TUT9FrMvEYVwFXFR7/view?usp=drive_link",
      },
      {
        subject: "Biology",
        downloadLink:
          "https://drive.google.com/file/d/1btXugvRayQQ5ZVdU1V-JjhSwIPygMAmA/view?usp=drive_link",
      },
    ],
  },
  {
    id: 2,
    title: "NCERT 11",
    resourceImg: ncert11,
    resource: [
      {
        subject: "History Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1-0eksD_5g9jB5ZGTtjYjD4sWkPSr0-9O/view?usp=drive_link",
      },
      {
        subject: "History Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1aK2dbVtF5q11WfZqFUnBVxd0aVLrSf7e/view?usp=drive_link",
      },
      {
        subject: "Introduction To Indian Art",
        downloadLink:
          "https://drive.google.com/file/d/1_Q37ymKAQ-ZYmuPaZu1Hk03N3LkNIK3m/view?usp=drive_link",
      },
      {
        subject: "Heritage Crafts",
        downloadLink:
          "https://drive.google.com/file/d/176_HtUYrPEs9FMfUzv_5DiKkTjWhFR3D/view?usp=drive_link",
      },
      {
        subject: "Geography",
        downloadLink:
          "https://drive.google.com/file/d/1DDxuqHzR1ye99h2YXiebG2AYYSnhke5N/view?usp=drive_link",
      },
      {
        subject: "Indian Physical Environment",
        downloadLink:
          "https://drive.google.com/file/d/11JCRWeLqZM87M0eU7pqEuVTNLL8f6Ht3/view?usp=drive_link",
      },
      {
        subject: "Indian Constitution",
        downloadLink:
          "https://drive.google.com/file/d/1nY6QThwYqRq6i27ImuoMxu6XnL3qrPXA/view?usp=drive_link",
      },
      {
        subject: "Political Theory",
        downloadLink:
          "https://drive.google.com/file/d/1lasaD8SuBLBEUIVEmFe0rBIoyKNYfWDU/view?usp=drive_link",
      },
      {
        subject: "Economics",
        downloadLink:
          "https://drive.google.com/file/d/1HJ9uKIwAT6N5kKvV6FnnuZvYOgRa_vx_/view?usp=drive_link",
      },
      {
        subject: "Sociology Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1o6WgUzJiTRDQ9wP-a0NTRmTRYfZpVC8e/view?usp=drive_link",
      },
      {
        subject: "Sociology Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1jETSr39jhH7EiyLdzB9tmOwYbRDB4D9L/view?usp=drive_link",
      },
      {
        subject: "Physics Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1bTWGKho4NCr3qraWDPSgzvjVX84aTFwY/view?usp=drive_link",
      },
      {
        subject: "Physics Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1s3-nE3T9v9O5ASyba1J3NUzldxPGP9_d/view?usp=drive_link",
      },
      {
        subject: "Chemistry Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1R3eSL32zuOMWZhKlvJuQuoTbj0O8jnXL/view?usp=drive_link",
      },
      {
        subject: "Chemistry Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1AOOqWk2BsxGnIRHXCep_XyXmmr9gwVRw/view?usp=drive_link",
      },
      {
        subject: "Biology",
        downloadLink:
          "https://drive.google.com/file/d/1i2K6p-wYQkRVd9wPnnD_yTWGB4moOqii/view?usp=drive_link",
      },
    ],
  },
  {
    id: 3,
    title: "General Knowledge",
    resourceImg: gk,
    resource: [
      {
        subject: "GK For All Competative Exams",
        downloadLink:
          "https://drive.google.com/file/d/1EuPYIH2-g17uwqEtBtC3iXcUPGB8O-R-/view?usp=drive_link",
      },
    ],
  },
  {
    id: 4,
    title: "IGNOU",
    resourceImg: ignou,
    resource: [
      {
        subject: "Social And Political Thoughts",
        downloadLink:
          "https://drive.google.com/file/d/12GThiPzVzpeUpNCwsxvgSHvsMUUx7_zy/view?usp=drive_link",
      },
      {
        subject: "India Democracy And Development",
        downloadLink:
          "https://drive.google.com/file/d/1YbriyvP7Faw6modN9_Cw3nCCvAYq82Df/view?usp=drive_link",
      },
      {
        subject: "Government and Politics In India",
        downloadLink:
          "https://drive.google.com/file/d/1dsAhtRofR5pwd6-RUnpjU2FmlSgzFnFK/view?usp=drive_link",
      },
      {
        subject: "Ethics",
        downloadLink:
          "https://drive.google.com/file/d/10Wso-bVFmwTaZPkVp9qF10Wv45iOn5j4/view?usp=drive_link",
      },
      {
        subject: "Environment - Ecology",
        downloadLink:
          "https://drive.google.com/file/d/1cDe7_ekEhSO5xgqF_1Ef8WhM_q2Ejvtu/view?usp=drive_link",
      },
    ],
  },
  {
    id: 5,
    title: "NIOS",
    resourceImg: nios,
    resource: [
      {
        subject: "Macro Economics",
        downloadLink:
          "https://drive.google.com/file/d/1zUZ_nqCWIA0oiEWvUcHpcEnpHHRz8zon/view?usp=drive_link",
      },
      {
        subject: "Indian Culture And Heritage",
        downloadLink:
          "https://drive.google.com/file/d/1Mx8Zi6HjtXhZXsmpxDMi9o93Ny79pbkS/view?usp=drive_link",
      },
      {
        subject: "Geography Part-1",
        downloadLink:
          "https://drive.google.com/file/d/1MVT1uB5krVCneDJ6XAGWlLRhVsJK0W_t/view?usp=drive_link",
      },
      {
        subject: "Geography Part-2",
        downloadLink:
          "https://drive.google.com/file/d/1VIVSRk9zTJElYS3pAO47zNeVmzfvHuy6/view?usp=drive_link",
      },
      {
        subject: "Physics",
        downloadLink:
          "https://drive.google.com/file/d/1niY5x_ORS4bMSjijj4NCm4YomcoXVf7x/view?usp=drive_link",
      },
      {
        subject: "Chemistry",
        downloadLink:
          "https://drive.google.com/file/d/1c_WJ_0C-Lz5zht7wI1nJwTDIKWCcZMuH/view?usp=drive_link",
      },
      {
        subject: "Biology",
        downloadLink:
          "https://drive.google.com/file/d/12Xn8vMrExJv9vmj7Hh38AlndWUGW92Ri/view?usp=drive_link",
      },
    ],
  },
  {
    id: 6,
    title: "Economic Survey",
    resourceImg: economicsurvey,
    resource: [
      {
        subject: "Economic Survey 2024 - 2025",
        downloadLink:
          "https://www.indiabudget.gov.in/economicsurvey/doc/echapter.pdf",
      },
    ],
  },
  {
    id: 7,
    title: "India Budget",
    resourceImg: budget,
    resource: [
      {
        subject: "Budget 2025",
        downloadLink:
          "https://drive.google.com/file/d/1SHL159Q0vvgxNmJf3T6snj96OIV2OmWG/view?usp=drive_link",
      },
    ],
  },
];
